import script from "./DashBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./DashBoard.vue?vue&type=script&setup=true&lang=js"

import "./DashBoard.vue?vue&type=style&index=0&id=ae888f2a&scoped=true&lang=css"

import exportComponent from "/home/xs909715/manage-sys.net/deploy/call-center-fe/production/releases/5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae888f2a"]])

export default __exports__